"use strict";
var pushNotification = function(posTop, posRight, title, description, type) {
    var notification = document.createElement("div");
    var notificationTitle = document.createElement("h2");
    var notificationDescription = document.createElement("p");
    notification.classList.add("notification", type);
    notification.style.top = "".concat(posTop, "px");
    notification.style.right = "".concat(posRight, "px");
    notificationTitle.classList.add("title");
    notificationTitle.textContent = title;
    description.split("\n").forEach(function(line, index) {
        if (index > 0) notificationDescription.append(document.createElement("br"));
        notificationDescription.append(line);
    });
    notification.append(notificationTitle, notificationDescription);
    document.body.appendChild(notification);
    setTimeout(function() {
        notification.style.display = "none";
    }, 2000);
};
pushNotification(10, 10, "Title of Success message", "Message example.\n Notification should contain title and description.", "success");
pushNotification(150, 10, "Title of Error message", "Message example.\n Notification should contain title and description.", "error");
pushNotification(290, 10, "Title of Warning message", "Message example.\n Notification should contain title and description.", "warning"); // test commit

//# sourceMappingURL=index.9e269f96.js.map
